import React from 'react';
import Navbar from './Navbar/Navbar'


import QuizApp1 from './QuizApp1';


function QuizScreen1 () {
 
    return (
      <div className="App">          
      
        <QuizApp1></QuizApp1>
      </div>
    );
  }


export default QuizScreen1;
